import { NgModule } from '@angular/core';

import { FeatureToggleModule } from 'ish-core/feature-toggle.module';
import { LAZY_FEATURE_MODULE } from 'ish-core/utils/module-loader/module-loader.service';

import { LazyMasterProductVariationComponent } from './lazy-master-product-variation/lazy-master-product-variation.component';

@NgModule({
  imports: [FeatureToggleModule],
  providers: [
    {
      provide: LAZY_FEATURE_MODULE,
      useValue: {
        feature: 'productVariationList',
        location: () =>
          import('../store/product-variation-list-store.module').then(m => m.ProductVariationListStoreModule),
      },
      multi: true,
    },
  ],
  declarations: [LazyMasterProductVariationComponent],
  exports: [LazyMasterProductVariationComponent],
})
export class ProductVariationListExportsModule {}
